/* eslint-disable array-callback-return */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { getAllEnumerations, getAuthorizationCustomFields, getClientInformation, getClientFieldListValues, getClientSpecificFields, getAllCountries, getAllProvinces, getTempPendingAuthClientCustomFields } from '../authorizations.actions';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CustomDatePicker from '../../../common/customDatePicker.component';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InfoIcon from '@material-ui/icons/Info';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
// import WarningIcon from '@material-ui/icons/Warning';
// import moment from 'moment';

// import { dateDiffDays } from '../../../utilities/dateFormatter';
import { detectIE } from '../../../utilities/browserUtils';
import {
  getSelectedClientInformation,
  // userHasPermission,
  isAirBornClient,
  isKlaTaxClient, //Added via AB#869
  // isBattelleEnergyAllianceClient,
  isSamsungClient, 
  // isSolenisClient,
  // isKLAClient,
} from '../../../utilities/authUtils';
import { requiredField, validDate } from '../../../utilities/fieldValidation';

// import { CurrencyFormat, IntegerFormat, TwoDecimalFormat } from '../../../common/numberFormatCustom.component';
// import { removeLettersFromBusCode } from './utils';
import { isEstimatedEndDateMoveType } from './utils';
import ContactForm from './contactForm.component';
import CustomSelect from '../../../common/customSelect.component';
import Typography from '@material-ui/core/Typography';
// import { defaultFieldsBasedOnReloPolicy } from './customClientLogic';
import { CostUnit, displayCost } from 'utilities/currencyFormatter';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
//import Truncate from 'react-truncate';


// const NONE = 'none';
let moveTypeIsRequired = false;

// const safeIncludes = (value, search) => (typeof value === 'string' ? value.includes(search) : false);

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    '& .MuiFormLabel-asterisk': {
      display: 'none',
    },
  },
  inputRoot: {
    zIndex: 0,
  },
  input: {
    height: 'auto',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    zIndex: 0,
    height: 'auto',
  },
  textFieldMedium: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 225,
    maxWidth: 400,
    zIndex: 0,
    height: 'auto',
  },
  textFieldWide: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 275,
    maxWidth: 475,
    zIndex: 0,
    height: 'auto',
  },
  menu: {
    width: 200,
  },
  paperSection: {
    width: '100%',
    padding: '1rem',
    marginBottom: '0.75rem',
  },
  gridButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

class EmployeeForm extends Component {
  // constructor(props) {
  //   super(props);

  //   // this.getDivisionSelectComponent = this.getDivisionSelectComponent.bind(this);
  //   // this.divisionIdIsSelected = this.divisionIdIsSelected.bind(this);
  //   // this.getFilteredBusCodes = this.getFilteredBusCodes.bind(this);
  //   // this.getDivisionBusCode = this.getDivisionBusCode.bind(this);
  // }

  async componentDidMount() {
      this._isMounted = true;
      // this.props.getCountries();
      // this.props.getStates();

      let clientId = getSelectedClientInformation() && getSelectedClientInformation().id ? parseInt(getSelectedClientInformation().id) : null;

      // this.props.getTempPendingAuthClientCustomFields();
      await this.props.getClientInformation(clientId);
      this.props.getAllEnumerations();
      this.props.getAllCountries();
      this.props.getAllProvinces();
      // await this.props.getAuthorizationCustomFields();
      // await this.props.getClientSpecificFields({ AuthorizationID: null });
      // await this.props.getClientFieldListValues();
      // this.props.getReloPolicies();
      // if (userHasPermission('selfService:policies', this.props.clientDivisions)) {
      //   this.props.getPolicies();
      // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

//   getSelectedPolicyBudget = (selfServicePolicies, selectedPolicyId) => {
//     const selectedPolicy = selfServicePolicies.find((pol) => pol.clientPolicyId === selectedPolicyId);
//     if (selectedPolicy) {
//       return selectedPolicy.budget;
//     }
//   };

//   getSelfServicePolicyMenuItems(selfServicePolicies, reloPolicy, selectedPolicyId) {
//     const selectedPolicy = selfServicePolicies.find((pol) => pol.clientPolicyId === selectedPolicyId);
//     const filteredPolicies = selfServicePolicies.filter(((ssPol) => {
//       if (ssPol.moveTrackPolicies && ssPol.moveTrackPolicies.length) {
//         return ssPol.moveTrackPolicies.some((mtPol) => mtPol.name === reloPolicy);
//       }
//       return false;
//     }));
//     const menuItems = filteredPolicies.map((policy) => {
//       return (
//         <MenuItem key={policy.clientPolicyId} value={policy.clientPolicyId}>
//           {policy.name}
//         </MenuItem>
//       );
//     });
//     menuItems.push(
//       <MenuItem key="" value={NONE}>
//         None
//       </MenuItem>,
//     );
//     // if our selected policy was filtered out, add it as a disabled option
//     if (!filteredPolicies.some((pol) => pol.clientPolicyId === selectedPolicyId)) {
//       if (selectedPolicy) {
//         menuItems.push(
//           <MenuItem key={selectedPolicy.clientPolicyId} value={selectedPolicy.clientPolicyId} disabled>
//             {selectedPolicy.name}
//           </MenuItem>,
//         );
//       }
//     }
//     return menuItems;
//   }

//   defaultFieldsBasedOnReloPolicy(reloPolicy) {
//     const clientId = getSelectedClientInformation().id;
//     const clientSpecificFunction = defaultFieldsBasedOnReloPolicy[clientId];
//     if (clientSpecificFunction) {
//       clientSpecificFunction(reloPolicy, this.props.handleFormChange);
//     }
//   }

    parseStringToArray(string) {
        if (string && string.length > 0) {
            return string.split(';');
        }
        return [];
      }

    renderCustomField(field, formData, divisions, reloPolicies, customFields, customFieldValues) {
        // If field is dependent on another field to be displayed, check if that field has a value before rendering
        let customField = customFields && customFields.length > 0 ? customFields.find(f => f.customFieldCommonId === field.customFieldCommonId) : null;

        if (customField && customField.customFieldDependencies && customField.customFieldDependencies.length > 0) {
          //check if depedent conditions are met by looping through all dependencies and checking values
          let displayfield = false;
          let renderListValues = [];
          let makeRequiredField = false;

          const dependencyListValues = [];
          let dependencyRequiresField = false;

          const evaluateDependency = (dependency) => {
            let dependentField = dependency.fieldDependentOnId;
            let dependentOperation = dependency.fieldDependentOnOperationId;
            let dependentOnValue = dependency.fieldDependentOnValueId;

            // parse if field is dependent on division or relo policy
            if(dependentField === 'Division') {
              dependentField = 'divisionId';
              const dependentDivisions = this.parseStringToArray(dependentOnValue);
              dependentOnValue = [];
              dependentDivisions.forEach((division) => {
                if (divisions && divisions.length > 0) {
                  const matchedDivision = divisions.find((div) => div.divisionName === division);
                  if (matchedDivision) {
                    dependentOnValue.push(matchedDivision.clientDivisionId);
                  }
                }
              });
            }
            else if(dependentField === 'Relocation Policy') {
              dependentField = 'policyId';
              const dependentPolicies = this.parseStringToArray(dependentOnValue);
              dependentOnValue = [];
              dependentPolicies.forEach((policy) => {
                if (reloPolicies && reloPolicies.length > 0) {
                  const matchedPolicy = reloPolicies.find((policyItem) => policyItem && policyItem.policy && policyItem.policy.policyDescription === policy);
                  if (matchedPolicy) {
                    dependentOnValue.push(matchedPolicy.policy.relocationPolicyId);
                  }
                }
              });
            }
            else {
              const matchedDependentCustomField = customFields && customFields.length > 0
                ? customFields.find((fieldItem) => fieldItem.fieldLabel === dependentField)
                : null;
              dependentField = matchedDependentCustomField ? matchedDependentCustomField.customFieldCommonId : null;
            }

            const tempFile = formData && formData.selectedAuth && formData.selectedAuth.tempFile
              ? formData.selectedAuth.tempFile
              : {};
            const dependentCustomFieldValue = dependentField !== 'policyId' && dependentField !== 'divisionId' && Array.isArray(customFieldValues)
              ? customFieldValues.find((fieldValue) => fieldValue.customFieldCommonId === dependentField)
              : null;
            const dependentCustomFieldRawValue = dependentCustomFieldValue ? dependentCustomFieldValue.fieldValue : null;

            let dependentFieldValue = dependentField === 'policyId'
              ? (tempFile.policyId ?? tempFile.PolicyId ?? null)
              : dependentField !== 'divisionId'
                ? dependentCustomFieldRawValue
                : tempFile[dependentField];

            const candidateValues = Array.isArray(dependentOnValue) ? dependentOnValue : [dependentOnValue];
            const matchesDependency = candidateValues.some((value) => {
              switch (dependentOperation) {
              case '98ba1156-a956-45db-9d68-10f2e345b7f9': // is equal
                return dependentFieldValue === value;
              case '6b8ec837-01c9-4773-ad3c-0e6c41263678': // is not equal
                return dependentFieldValue !== value;
              case '9b12aa29-1027-40a0-9843-8d861d688249': // is not null
                return dependentFieldValue != null && dependentFieldValue !== '';
              case 'd73311f5-41bc-4e0e-8048-92b0722c5bae': // is null
                return dependentFieldValue == null || dependentFieldValue === '';
              case 'e78add1f-2d1c-4241-b15b-2a7dcf12657d': // is greater than
                return dependentFieldValue > value;
              case '01a99433-8b24-4ac8-a004-7e9c8e17c3a0': // is less than
                return dependentFieldValue < value;
              default:
                return false;
              }
            });

            return {
              matchesDependency,
              resultingListValues: dependency.resultingListValues,
              isMakeRequired: dependency.isMakeRequired,
            };
          };

          const dependenciesByFieldId = customField.customFieldDependencies.reduce((grouped, dependency) => {
            const key = dependency && dependency.fieldDependentOnId ? dependency.fieldDependentOnId : '__unknown_dependency__';
            if (!grouped[key]) {
              grouped[key] = [];
            }
            grouped[key].push(dependency);
            return grouped;
          }, {});

          const allDependenciesMet = Object.keys(dependenciesByFieldId).every((fieldDependentOnId) => {
            const groupedDependencies = dependenciesByFieldId[fieldDependentOnId] || [];
            const groupedResults = groupedDependencies.map((dependency) => evaluateDependency(dependency));
            const matchedResults = groupedResults.filter((result) => result.matchesDependency);

            // If multiple dependency records target the same fieldDependentOnId, only one must match.
            if (matchedResults.length > 0) {
              matchedResults.forEach((result) => {
                if (result.resultingListValues && result.resultingListValues.length > 0) {
                  dependencyListValues.push(this.parseStringToArray(result.resultingListValues));
                }
                if (result.isMakeRequired) {
                  dependencyRequiresField = true;
                }
              });
            }

            return matchedResults.length > 0;
          });

          displayfield = allDependenciesMet;
          if (displayfield) {
            makeRequiredField = dependencyRequiresField;
            if (dependencyListValues.length > 0) {
              renderListValues = dependencyListValues[dependencyListValues.length - 1];
            }
          }

            if (displayfield) {
                // render as expected
                // List
                if(field.fieldTypeId === '5abfc239-5144-4155-91c2-68a71755f995')
                {
                    return (
                        <CustomSelect
                            id={field.customFieldCommonId}
                            key={field.customFieldCommonId}
                            options={Array.isArray(renderListValues)
                              ? renderListValues
                              : (typeof renderListValues === 'string' && renderListValues.length > 0
                                ? renderListValues.split(';')
                                : (Array.isArray(field.fieldListValues)
                                  ? field.fieldListValues
                                  : (typeof field.fieldListValues === 'string' && field.fieldListValues.length > 0
                                    ? field.fieldListValues.split(';')
                                    : [])))}
                            placeholder={field.fieldLabel}
                            validator={field.isRequiredField ? requiredField : null}
                          onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                            value={field.fieldValue ?? ''}
                            disabled={this.props.readonly}
                            longerSelect={true}
                            required={makeRequiredField ? true : field.isRequiredField}
                            helperText={makeRequiredField || field.isRequiredField ? 'Required' : null}
                            />
                    )
                }
                // Text or number
                if(field.fieldTypeId === 'cf3f707f-2e66-4984-91d8-458c3b7b457b' || field.fieldTypeId === 'be93d180-6321-4a4a-9627-282ebe438d78')
                {
                    return (
                        <TextField
                            key={field.customFieldCommonId}
                            label={field.fieldLabel}
                            className={this.props.classes.textField}
                            value={field.fieldValue ?? ''}
                          onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                            margin="normal"
                            required={makeRequiredField ? true : field.isRequiredField}
                            helperText={makeRequiredField || field.isRequiredField ? 'Required' : null}
                            disabled={this.props.readonly}
                        />
                    )
                }
                // Date
                if(field.fieldTypeId === '1235AE4C-BA8F-4BA6-91C7-2AF61524325A')
                {
                    return (
                        <TextField
                            key={field.customFieldCommonId}
                            label={field.fieldLabel}
                            type="date"
                            style={{ width: '250px' }}
                          onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                            value={field.fieldValue ?? null}
                            margin="normal"
                            InputLabelProps={{
                            shrink: true,
                            }}
                            className={this.props.classes.textField}
                            disabled={this.props.readonly}
                            required={makeRequiredField ? true : field.isRequiredField}
                            helperText={makeRequiredField || field.isRequiredField ? 'Required' : null}
                        />
                    )
                }
                // Bool
                // Update: turn this into a yes/no dropdown
                if(field.fieldTypeId === '725cc7d4-507f-4305-ad68-4d412a73ee70')
                {
                    return (
                    <TextField
                      key={field.customFieldCommonId}
                      select
                      label={field.fieldLabel}
                      className={this.props.classes.textField}
                      value={field.fieldValue == null ? '' : field.fieldValue}
                      onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                      margin="normal"
                      required={makeRequiredField ? true : field.isRequiredField}
                      helperText={makeRequiredField || field.isRequiredField ? 'Required' : null}
                      SelectProps={{
                        MenuProps: {
                        className: this.props.classes.menu,
                        },
                      }}
                      disabled={this.props.readonly}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                    )
                }
            }
            else {
                return null;
            }
        }
        else {
            // List
            if(field.fieldTypeId === '5abfc239-5144-4155-91c2-68a71755f995')
            {
                return (
                    <CustomSelect
                      id={field.customFieldCommonId}
                      key={field.customFieldCommonId}
                      options={(Array.isArray(field.fieldListValues)
                            ? field.fieldListValues
                            : (typeof field.fieldListValues === 'string' && field.fieldListValues.length > 0
                              ? field.fieldListValues.split(';')
                              : []))}
                      placeholder={field.fieldLabel}
                      validator={field.isRequiredField ? requiredField : null}
                    onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                      value={field.fieldValue ?? ''}
                      disabled={this.props.readonly}
                      longerSelect={true}
                      required={field.isRequiredField}
                      helperText={field.isRequiredField ? 'Required' : null}
                      />
                )
            }
            // Text or number
            if(field.fieldTypeId === 'cf3f707f-2e66-4984-91d8-458c3b7b457b' || field.fieldTypeId === 'be93d180-6321-4a4a-9627-282ebe438d78')
            {
                return (
                    <TextField
                        key={field.customFieldCommonId}
                        label={field.fieldLabel}
                        className={this.props.classes.textField}
                        value={field.fieldValue ?? ''}
                        onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                        margin="normal"
                        required={field.isRequiredField}
                        helperText={field.isRequiredField ? 'Required' : null}
                        disabled={this.props.readonly}
                    />
                )
            }
            // Date
            if(field.fieldTypeId === '1235AE4C-BA8F-4BA6-91C7-2AF61524325A')
            {
                return (
                    <TextField
                        key={field.customFieldCommonId}
                        label={field.fieldLabel}
                        type="date"
                        style={{ width: '250px' }}
                      onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                        value={field.fieldValue ?? ''}
                        margin="normal"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        className={this.props.classes.textField}
                        disabled={this.props.readonly}
                        required={field.isRequiredField}
                        helperText={field.isRequiredField ? 'Required' : null}
                    />
                )
            }
            // Bool
            if(field.fieldTypeId === '725cc7d4-507f-4305-ad68-4d412a73ee70')
            {
                return (
                <TextField
                  key={field.customFieldCommonId}
                  select
                  label={field.fieldLabel}
                  className={this.props.classes.textField}
                  value={field.fieldValue == null ? '' : field.fieldValue}
                  onChange={this.props.handleCustomFieldChange(field.customFieldCommonId)}
                  margin="normal"
                  required={field.isRequiredField}
                  helperText={field.isRequiredField ? 'Required' : null}
                  SelectProps={{
                    MenuProps: {
                    className: this.props.classes.menu,
                    },
                  }}
                  disabled={this.props.readonly}
                >
                  <MenuItem value="">Select...</MenuItem>
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </TextField>
                )
            }
        }

    }

  renderEstimatedEndDate(isIE) {
    const { classes, formData, handleFormChange, readonly } = this.props;
    const fileInfo = formData.selectedAuth ? formData.selectedAuth.tempFile : null;

    if (!fileInfo || !isEstimatedEndDateMoveType(fileInfo.moveTypeId)) {
      return null;
    }

    if (isIE) {
      return (
        <div style={{ marginLeft: '0.5rem' }}>
          <CustomDatePicker
            selected={fileInfo.estimatedEndDate}
            onChange={handleFormChange('estimatedEndDate')}
            label="Estimated End Date"
            disabled={readonly}
          />
        </div>
      );
    }

    return (
      <TextField
        id="endDate"
        label="Estimated End Date"
        helperText={validDate(fileInfo.estimatedEndDate)}
        type="date"
        style={{ width: '250px' }}
        onChange={handleFormChange('estimatedEndDate')}
        value={fileInfo.estimatedEndDate ? fileInfo.estimatedEndDate : ''}
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        className={classes.textField}
        disabled={readonly}
      />
    );
  }

  render() {
    const {
      classes,
      formData,
      handleFormChange,
      handleOnBlur,
      handleContactChange,
      handleCheckboxChange,
      // handleCustomFieldChange,
      // handleClientCustomFieldChange,
      isEdit,
      readonly,
      duplicateAuthHelperText,
      clientInfo,
      countryEnums,
      provinceEnums,
      // clientFields,
      allEnums,
      hasConfidentialFileAccess
    } = this.props;

    const fileInfo = formData.selectedAuth ? formData.selectedAuth.tempFile : null;
    
    // let shortTermAssignment = false;
    // let longTermAssignment = false;
    // let showDateStartEndWarning = false;
    // if (formData.selectedAuth && formData.selectedAuth.effectiveDate) {
    //   const diff = dateDiffDays(new Date(formData.selectedAuth.effectiveDate), new Date(ProposedEndDate));
    //   shortTermAssignment = diff < 365;
    //   longTermAssignment = diff >= 365;
    //   showDateStartEndWarning = diff <= 0;
    // }

    const isIE = detectIE();
    // filter state options by selected country, default USA
    // const oldStateOptions = this.getProvinces(OldCountry);
    // const newStateOptions = this.getProvinces(NewCountry);

    const countryOptions = Array.isArray(countryEnums)
      ? countryEnums.map((country) => ({
        value: country.id,
        label: country.title,
      }))
      : [];
      
    const provinceOptions = Array.isArray(provinceEnums)
      ? provinceEnums.map((province) => ({
        value: province.id,
        label: province.title,
        countryId: province.countryId
      }))
      : [];

    // const empTypeOptions = formData.clientFieldValues.filter((item) => item.PageFieldId === 6);
    // const ownerStatusOptions = formData.clientFieldValues.filter((item) => item.PageFieldId === 26);
    const reloPolicies =  clientInfo && clientInfo.clientRelocationPolicies && Array.isArray(clientInfo.clientRelocationPolicies) ? clientInfo.clientRelocationPolicies : [];
    const divisions = clientInfo && clientInfo.clientDivisions && Array.isArray(clientInfo.clientDivisions) ? clientInfo.clientDivisions : [];
    const clientCustomFields = clientInfo && clientInfo.clientCustomFields && Array.isArray(clientInfo.clientCustomFields) ? clientInfo.clientCustomFields : [];
    const enums = allEnums ? allEnums : {};
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const hasNonEmptyGuid = ({ id }) => typeof id !== 'string' || id.toLowerCase() !== emptyGuid;
    const employeeTypeOrder = ['New Hire', 'Transfer', 'Candidate', 'Non-Relo'];
    const employeeTypes = Array.isArray(enums.employeeTypes)
      ? enums.employeeTypes
        .filter(hasNonEmptyGuid)
        .map((employeeType, index) => ({ employeeType, index }))
        .sort((left, right) => {
          const leftOrder = employeeTypeOrder.indexOf(left.employeeType.title);
          const rightOrder = employeeTypeOrder.indexOf(right.employeeType.title);
          return (leftOrder < 0 ? employeeTypeOrder.length : leftOrder)
            - (rightOrder < 0 ? employeeTypeOrder.length : rightOrder)
            || left.index - right.index;
        })
        .map(({ employeeType }) => employeeType)
      : [];
    
    let moveTypesTemp = Array.isArray(enums.moveTypes)
      ? enums.moveTypes.filter(hasNonEmptyGuid).sort((left, right) => {
        const leftTitle = String(left.title || '').trim().toLowerCase();
        const rightTitle = String(right.title || '').trim().toLowerCase();
        return leftTitle.localeCompare(rightTitle);
      })
      : [];

    let permMove = moveTypesTemp.filter(moveType => moveType.title && moveType.title === 'Domestic Permanent Move');
    let moveTypes = [...permMove];
    moveTypesTemp.forEach(moveType => {
      if (moveType.title && moveType.title !== 'Domestic Permanent Move') {
        moveTypes.push(moveType);
      }
    });

    console.log(moveTypes);
    const ownershipTypeOrder = ['homeowner', 'renter', 'n/a'];
    const ownershipTypes = Array.isArray(enums.ownershipTypes)
      ? enums.ownershipTypes.filter(hasNonEmptyGuid).sort((left, right) => {
        const leftTitle = left.title.toLowerCase();
        const rightTitle = right.title.toLowerCase();
        const leftOrder = ownershipTypeOrder.indexOf(leftTitle);
        const rightOrder = ownershipTypeOrder.indexOf(rightTitle);
        return (leftOrder < 0 ? ownershipTypeOrder.length : leftOrder)
          - (rightOrder < 0 ? ownershipTypeOrder.length : rightOrder)
          || leftTitle.localeCompare(rightTitle);
      })
      : [];
    const isPtCodeProcessActive = !!(clientInfo && clientInfo.clientDetails && clientInfo.clientDetails.isPtCodeProcessActive);
    const ptCodeHistories = formData && formData.selectedAuth && Array.isArray(formData.selectedAuth.tempPTCodeHistories)
      ? formData.selectedAuth.tempPTCodeHistories
      : [];
    // let selfServicePolicies = formData.selfServicePolicies || [];
    
    // const divisionSelect = this.getDivisionSelectComponent();
    // const divisionBusCode = this.getDivisionBusCode();

    // let isSelectedDivisionFiltered = false;
    // let isShowDivisionRequiredMessage = false;
    // let costCenters = [];
    // let divisionPolicies = reloPolicies;
    // if (divisionBusCode) {
    //   let busCodeKey = divisionBusCode.BusCodeKey !== null ? divisionBusCode.BusCodeKey.toString() : null;
    //   if (busCodeKey === null && isEdit) busCodeKey = '0'; // treat null the same as 0-level
    //   isSelectedDivisionFiltered = busCodeKey === null ? false : !this.divisionIdIsSelected(busCodeKey);
    //   isShowDivisionRequiredMessage = busCodeKey === null && !isEdit;
    // }

    // //if client ID is 238 (MPC) or 242 (Speedway), don't require the moveType field
    // if(getSelectedClientInformation().id !== '238' && getSelectedClientInformation().id !== '242') moveTypeIsRequired = true;

    // //if client ID is 274 (Foxconn) or 317 (Samsung), filter Program Type by division selected
    // if((getSelectedClientInformation().id === '274' || isSamsungClient()) && formData.busCodes && divisionBusCode)
    // {
    //   divisionPolicies = [];
    //   let busCodeOptions = this.getBusCodes('BC1');
    //   let divs = busCodeOptions.filter((code) => code.BusCodeKey === divisionBusCode.BusCodeKey);
    //   let policies = divs[0] && divs[0].User7 ? divs[0].User7.split(';') : [""];
    //   policies.map((policy) => {
    //     // for every policy given for the selected division, we will grab each respective policy from reloPolicies
    //     let temp = reloPolicies.filter((code) => code.PolicyId === parseInt(policy));
    //     if (temp[0]) {
    //       divisionPolicies.push(temp[0]);
    //     } 
    //     return divisionPolicies;
    //   });

    //   if (divisionPolicies.length === 0) {
    //     divisionPolicies = reloPolicies;
    //   }
    // }

    // //if client ID is 184 (Acushnet), filter Program Type by division selected - Added 3/14/2025 for AB#1340 by Vanessa Osterberg
    // if(getSelectedClientInformation().id === '184' && formData.busCodes && divisionBusCode)
    //   {
    //     costCenters = [];
    //     let busCodeOptions = this.getBusCodes('BC1');
    //     let divs = busCodeOptions.filter((code) => code.BusCodeKey === divisionBusCode.BusCodeKey);
    //     let policies = divs[0] && divs[0].User9 ? divs[0].User9.split(';') : [""];
  
    //     if (costCenters.length === 0) {
    //       costCenters = policies;
    //     }
    //   }
    
    // const hasSelfServicePermission = userHasPermission('selfService:policies', this.props.clientDivisions);
    // const selfServicePolicyMenuItems = this.getSelfServicePolicyMenuItems(selfServicePolicies, ReloPolicy, SelfServicePolicyId);
    // const allowEmptyDestination = userHasPermission('authorization:allowEmptyDestination', this.props.clientDivisions);

    // const hasSelfServicePermission = userHasPermission('selfService:policies', this.props.clientDivisions);
    // const selfServicePolicyMenuItems = this.getSelfServicePolicyMenuItems(selfServicePolicies, ReloPolicy, SelfServicePolicyId);
    // const allowEmptyDestination = userHasPermission('authorization:allowEmptyDestination', this.props.clientDivisions);
    return (
      <form className={classes.container} noValidate autoComplete="off">
        { clientInfo && clientInfo.clientDetails?.hasMultipleDivisions && (
          <Paper className={classes.paperSection}>
            <h3>Select Division</h3>
            <div>
                <TextField
                    id={fileInfo.divisionId}
                    select
                    label={'Division'}
                    className={classes.textFieldMedium}
                    style={{ width: '100%' }}
                    value={fileInfo && fileInfo.divisionId ? fileInfo.divisionId : 0}  //if this is null, then either set the value to 0 for top level, or '' for null option.
                    required={clientInfo.clientDetails?.hasMultipleDivisions}
                    helperText={clientInfo.clientDetails?.hasMultipleDivisions ? 'Required' : null}
                    SelectProps={{
                    MenuProps: {
                        className: classes.menu,
                    },
                    }}
                    disabled={readonly}
                    onChange={handleFormChange('divisionId')}
                >
                    {!isEdit &&
                    <MenuItem value="" />
                    }

                    {divisions.map((division, i) => {
                    return (
                        <MenuItem key={division.clientDivisionId} value={division.clientDivisionId}>
                        {division.divisionName}
                        </MenuItem>
                    );
                    })}
                </TextField>
            </div>

            {divisions && divisions.length > 1 &&
              <Grid container item style={{ marginTop: '1rem', paddingLeft: '1rem' }}>
                <div style={{ display: 'inline-flex' }}>
                  <InfoIcon />
                  <div style={{ lineHeight: '22px', marginLeft: '0.5rem', marginRight: '0.5rem', maxWidth: 550 }}>
                    Please select a division to create this authorization.
                  </div>
                </div>
              </Grid>
            }
          </Paper>
        )}
        <Paper className={classes.paperSection}>
          <h3>Employee Information</h3>
          <Grid container item>
            <TextField
              id="firstName"
              label="Transferee First Name"
              className={classes.textField}
              value={fileInfo.firstName ? fileInfo.firstName : ''}
              onChange={handleFormChange('firstName')}
              margin="normal"
              required
              helperText="Required"
              disabled={readonly}
            />
            <TextField
              id="lastName"
              label="Transferee Last Name"
              className={classes.textField}
              value={fileInfo.lastName ? fileInfo.lastName : ''}
              onChange={handleFormChange('lastName')}
              onBlur={handleOnBlur('lastName')}
              margin="normal"
              required
              helperText={duplicateAuthHelperText || 'Required'}
              disabled={readonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={fileInfo.isVIP}
                  onChange={handleCheckboxChange('isVIP')}
                  value={fileInfo.isVIP ? 'true' : 'false'}
                  disabled={readonly}
                />
              }
              label="VIP?"
            />
            {hasConfidentialFileAccess && <FormControlLabel
              control={
                <Checkbox
                  checked={fileInfo.isConfidentialFile}
                  onChange={handleCheckboxChange('isConfidentialFile')}
                  value={fileInfo.isConfidentialFile ? 'true' : 'false'}
                  disabled={readonly}
                />
              }
              label="Confidential File?"
            /> 
            }
          </Grid>
          <Grid container item>
            <TextField
              id="nickName"
              label="Transferee Nickname"
              className={classes.textField}
              value={fileInfo.nickName ? fileInfo.nickName : ''}
              onChange={handleFormChange('nickName')}
              margin="normal"
              disabled={readonly}
            />
          </Grid>
          <Grid container item>
            <TextField
              id="spouseFirstName"
              label="Spouse First Name"
              className={classes.textField}
              value={fileInfo.spouseFirstName ? fileInfo.spouseFirstName : ''}
              onChange={handleFormChange('spouseFirstName')}
              margin="normal"
              disabled={readonly}
            />
            <TextField
              id="spouseLastName"
              label="Spouse Last Name"
              className={classes.textField}
              value={fileInfo.spouseLastName ? fileInfo.spouseLastName : ''}
              onChange={handleFormChange('spouseLastName')}
              margin="normal"
              disabled={readonly}
            />
          </Grid>

          <Grid container item style={{ marginBottom: '1rem' }}>
            <TextField
              id="employeeTypeId"
              select
              label="Employee Type"
              className={classes.textField}
              value={fileInfo.employeeTypeId ? fileInfo.employeeTypeId : ''}
              onChange={handleFormChange('employeeTypeId')}
              margin="normal"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              required
              helperText="Required"
              disabled={readonly}
            >
              {employeeTypes.map((empType) => {
                return (<MenuItem key={empType.id} value={empType.id}>
                  {empType.title}
                </MenuItem>);
              })}
            </TextField>
          </Grid>
        </Paper>

        <Paper className={classes.paperSection}>
          <h3>Policy Information</h3>
          <Grid container item style={{ marginBottom: '1rem' }}>
            <TextField
              id="policyId"
              select
              label="Program Type"
              className={classes.textField}
              style={{ width: '250px' }}
              value={fileInfo.policyId ? fileInfo.policyId : ''}
              onChange={async (event) => {
                await handleFormChange('policyId')(event);
                // await handleFormChange('SelfServicePolicyId')('');
                // handleFormChange('SelfServicePolicyBudget')('');
                // this.defaultFieldsBasedOnReloPolicy(event.target.value);
              }}
              margin="normal"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              required
              helperText="Required"
              disabled={clientInfo && clientInfo.clientDetails?.hasMultipleDivisions ? fileInfo.divisionId === 0 : readonly}
            >
              {fileInfo.divisionId && reloPolicies && reloPolicies.filter((policy) => { 
                // TODO: Add back divison based policy filtering once the divison - policy relationship is finalized in ReloInsight Client module.
                if(policy.policyDivisions && policy.policyDivisions.length > 0) {
                  let division = policy.policyDivisions.find((div) => div.clientDivisionId === fileInfo.divisionId);
                  if(division) {
                    return policy;
                  }
                }
                return policy && policy.policy && policy.policy.relocationPolicyId;
              }).map((policy) => {
                return (<MenuItem key={policy.policy.relocationPolicyId} value={policy.policy.relocationPolicyId}>
                  {policy.policy.policyCode}
                </MenuItem>);
              })}
            </TextField>
          </Grid>

          {/* {hasSelfServicePermission && selfServicePolicyMenuItems.length > 1 &&
            <Grid container spacing={0} style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
              <Grid item>
                <Typography variant="body2">
                  Selecting a Self Service Policy will enable your employee to use the TRC planning tool to understand how to utilize their
                  relocation budget and get the most services they need to make their experience successful.
                </Typography>
              </Grid>
              <Grid item>
                <TextField
                  id="SelfServicePolicy"
                  select
                  label="Self Service Policy"
                  className={classes.textField}
                  style={{ width: '250px' }}
                  value={SelfServicePolicyId || NONE}
                  onChange={async (event) => {
                    if (event.target.value === NONE) {
                      await handleFormChange('SelfServicePolicyId')('');
                    } else {
                      await handleFormChange('SelfServicePolicyId')(event);
                    }
                    handleFormChange('SelfServicePolicyBudget')(this.getSelectedPolicyBudget(selfServicePolicies, event.target.value));
                  }}
                  margin="normal"
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  disabled={readonly || !ReloPolicy}
                >
                  {selfServicePolicyMenuItems}
                </TextField>

                <TextField
                  id="budget"
                  label="Budget"
                  className={classes.textField}
                  value={SelfServicePolicyBudget != null ? SelfServicePolicyBudget : ''}
                  InputProps={{ inputComponent: TwoDecimalFormat }}
                  inputProps={{ emitAsEvent: true }}
                  onChange={handleFormChange('SelfServicePolicyBudget')}
                  margin="normal"
                  disabled={readonly || !SelfServicePolicyId}
                />
              </Grid>
            </Grid>
          } */}

          <Grid container item style={{ marginBottom: '1.5rem' }}>
            <TextField
              id="moveTypeId"
              select
              label="Move Type"
              className={classes.textField}
              style={{ width: '250px' }}
              value={fileInfo.moveTypeId ? fileInfo.moveTypeId : ''}
              onChange={handleFormChange('moveTypeId')}
              margin="normal"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              required={moveTypeIsRequired}
              helperText={moveTypeIsRequired ? 'Required' : null}
              disabled={readonly}
            >
              {moveTypes.map((type) => {
                return (
                <MenuItem key={type.id} value={type.id}>
                  {type.title}
                </MenuItem>);
              })}
            </TextField>
            {isIE &&
              <div style={{ marginLeft: '0.5rem' }}>
                <CustomDatePicker
                  selected={fileInfo.effectiveDate}
                  onChange={handleFormChange('effectiveDate')}
                  label="Effective Date"
                  validator={(isAirBornClient() === true) ? requiredField : null}
                  disabled={readonly}
                  required={ (isAirBornClient() === true) ? true : false }
                  requiredText={(isAirBornClient() === true) ? 'Required' : null}
                />
              </div>
            }
            {!isIE && 
              <TextField
                id="startDate"
                label="Effective Date"
                validator={(isAirBornClient() === true) ? requiredField : null}
                helperText={validDate(fileInfo.effectiveDate) || (isAirBornClient() === true ? 'Required' : null)}
                type="date"
                style={{ width: '250px' }}
                onChange={handleFormChange('effectiveDate')}
                value={fileInfo.effectiveDate ? fileInfo.effectiveDate : ''}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                disabled={readonly}
                required={ (isAirBornClient() === true) ? true : false }
              />
            }
            {this.renderEstimatedEndDate(isIE)}
          </Grid>
          {/* <Grid container item style={{ marginBottom: '1rem', paddingLeft: '1rem' }}>
            {showDateStartEndWarning && <div style={{ display: 'inline-flex', width: '100%', marginBottom: '0.5rem' }}><WarningIcon /><div style={{ lineHeight: '22px', marginLeft: '0.5rem' }}>End Date Must Be After Start Date</div></div>}
            {longTermAssignment && <div style={{ display: 'inline-flex', width: '100%' }}><InfoIcon /><div style={{ lineHeight: '22px', marginLeft: '0.5rem' }}>Long Term Assignment (Duration &gt; 1 year)</div></div>}
            {shortTermAssignment && <div style={{ display: 'inline-flex', width: '100%' }}><InfoIcon /><div style={{ lineHeight: '22px', marginLeft: '0.5rem' }}>Short Term Assignment (Duration &lt; 1 year)</div></div>}
          </Grid> */}
        </Paper>

        {isKlaTaxClient() !== true && //isKlaTaxClient() logic added via AB#869
          <Paper className={classes.paperSection}>
            <h3>Departure Information</h3>
            <Grid container item>
              <TextField
                id="departureAddressLine1"
                label="Address Line 1"
                className={classes.textField}
                value={fileInfo.departureAddressLine1 ? fileInfo.departureAddressLine1 : ''}
                onChange={handleFormChange('departureAddressLine1')}
                margin="normal"
                helperText={(isSamsungClient() === true) ? null : 'Required'}
                required={(isSamsungClient() === true) ? false : true}
                disabled={readonly}
              />
              <TextField
                id="departureAddressLine2"
                label="Address Line 2"
                className={classes.textField}
                value={fileInfo.departureAddressLine2 ? fileInfo.departureAddressLine2 : ''}
                onChange={handleFormChange('departureAddressLine2')}
                margin="normal"
                disabled={readonly}
              />
              <TextField
                id="departureCity"
                label="City"
                className={classes.textField}
                value={fileInfo.departureCity ? fileInfo.departureCity : ''}
                onChange={handleFormChange('departureCity')}
                margin="normal"
                helperText="Required"
                required
                disabled={readonly}
              />
            </Grid>

            <Grid container item>
              <CustomSelect
                options={countryOptions || []}
                placeholder="Country"
                validator={requiredField}
                helperText="Required"
                onChange={handleFormChange('departureCountryId')}
                value={fileInfo.departureCountryId ? fileInfo.departureCountryId : 'd94a0819-59a2-443f-bc99-1ee360057f38'}
                disabled={readonly}
              />

              {/* <TextField
                id="departureCountryId"
                select
                label="Country"
                className={classes.textField}
                style={{ width: '250px' }}
                value={fileInfo.departureCountryId ? fileInfo.departureCountryId : ''}
                onChange={handleFormChange('departureCountryId')}
                margin="normal"
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                required={true}
                disabled={readonly}
              >
                {countryEnums && countryEnums.length > 0 && countryEnums.map((country) => {
                  return (
                  <MenuItem key={country.id} value={country.id}>
                    {country.title}
                  </MenuItem>);
                })}
              </TextField> */}

              {/* <TextField
                id="departureProvinceId"
                select
                label="State/Province"
                className={classes.textField}
                style={{ width: '250px' }}
                value={fileInfo.departureProvinceId ? fileInfo.departureProvinceId : ''}
                onChange={handleFormChange('departureProvinceId')}
                margin="normal"
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                required={false}
                disabled={readonly}
              >
                {provinceEnums && provinceEnums.length > 0 && Array.isArray(provinceEnums) && provinceEnums.filter((prov) => prov.countryId === fileInfo.departureCountryId).map((province) => {
                  return (
                  <MenuItem key={province.id} value={province.id}>
                    {province.title}
                  </MenuItem>);
                })}
              </TextField> */}

              <CustomSelect
                options={provinceOptions
                  ? provinceOptions.filter((province) => province.countryId === fileInfo.departureCountryId)
                  : []}
                placeholder="State/Province"
                validator={provinceOptions && provinceOptions.some((province) => province.countryId === fileInfo.departureCountryId) ? requiredField : null}
                helperText={provinceOptions && provinceOptions.some((province) => province.countryId === fileInfo.departureCountryId) ? 'Required' : null}
                onChange={handleFormChange('departureProvinceId')}
                value={fileInfo.departureProvinceId ? fileInfo.departureProvinceId : ''}
                disabled={readonly}

              />

              <TextField
                id="departureZipcode"
                label="Zip"
                className={classes.textField}
                value={fileInfo.departureZipcode ? fileInfo.departureZipcode : ''}
                onChange={handleFormChange('departureZipcode')}
                margin="normal"
                disabled={readonly}
              // helperText={requiredField(fileInfo.departureZipcode)}
              />

            </Grid>

            <Grid container item style={{ marginBottom: '1rem' }}>
                <TextField
                  id="departureOwnershipTypeId"
                  select
                  label="Ownership"
                  className={classes.textField}
                  value={fileInfo.departureOwnershipTypeId ? fileInfo.departureOwnershipTypeId : ''}
                  onChange={handleFormChange('departureOwnershipTypeId')}
                  margin="normal"
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  disabled={readonly}
                >
                  {/* {console.warn(ownerStatusOptions)} */}
                  {ownershipTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.title}
                    </MenuItem>
                  ))}
                </TextField>
            </Grid>
          </Paper>
        }
        
        {isKlaTaxClient() !== true && //isKlaTaxClient() logic added via AB#869
          <Paper className={classes.paperSection}>
            <h3>Destination Information</h3>
            <Grid container item>
              <TextField
                id="destinationAddressLine1"
                label="Address Line 1"
                className={classes.textField}
                value={fileInfo.destinationAddressLine1 ? fileInfo.destinationAddressLine1 : ''}
                onChange={handleFormChange('destinationAddressLine1')}
                margin="normal"
                disabled={readonly}
              />
              <TextField
                id="destinationAddressLine2"
                label="Address Line 2"
                className={classes.textField}
                value={fileInfo.destinationAddressLine2 ? fileInfo.destinationAddressLine2 : ''}
                onChange={handleFormChange('destinationAddressLine2')}
                margin="normal"
                disabled={readonly}
              />
              <TextField
                id="destinationCity"
                label="City"
                className={classes.textField}
                value={fileInfo.destinationCity ? fileInfo.destinationCity : ''}
                onChange={handleFormChange('destinationCity')}
                margin="normal"
                required={false}
                disabled={readonly}
                helperText="Required"
              />
            </Grid>

            <Grid container item style={{ marginBottom: '1rem' }}>
              <CustomSelect
                options={countryOptions}
                placeholder="Country"
                validator={requiredField}
                helperText="Required"
                onChange={handleFormChange('destinationCountryId')}
                value={fileInfo.destinationCountryId ? fileInfo.destinationCountryId : ''}
                disabled={readonly}
              />

              <CustomSelect
                options={provinceOptions
                  ? provinceOptions.filter((province) => province.countryId === fileInfo.destinationCountryId)
                  : []}
                placeholder="State/Province"
                validator={provinceOptions && provinceOptions.some((province) => province.countryId === fileInfo.destinationCountryId) ? requiredField : null}
                helperText={provinceOptions && provinceOptions.some((province) => province.countryId === fileInfo.destinationCountryId) ? 'Required' : null}
                onChange={handleFormChange('destinationProvinceId')}
                value={fileInfo.destinationProvinceId ? fileInfo.destinationProvinceId : ''}
                disabled={readonly}
              />

              <TextField
                id="destinationZipcode"
                label="Zip"
                className={classes.textField}
                value={fileInfo.destinationZipcode ? fileInfo.destinationZipcode : ''}
                onChange={handleFormChange('destinationZipcode')}
                margin="normal"
                disabled={readonly}
              />
            </Grid>

          </Paper>
        }
        
        {isKlaTaxClient() !== true && //isKlaTaxClient() logic added via AB#869
          <ContactForm formData={fileInfo} countries={countryEnums} handleContactChange={handleContactChange} readonly={readonly} />
        }
        <Paper className={classes.paperSection}>
          <h3>Employee Job Information</h3>
          <Grid container item>
            {(formData.selectedAuth.customFields && formData.selectedAuth.customFields.length > 0) &&
            <>
                {formData.selectedAuth.customFields.map((field) => {
                    return this.renderCustomField(field, formData, divisions, reloPolicies, clientCustomFields, formData.selectedAuth.customFields);
                })}
            </>}
        </Grid>
        {isPtCodeProcessActive &&
          <>
            {ptCodeHistories.map((ptCode, index) => {
              return (
                <>
                  <br/>
                  <Grid container item key={`pt-code-${index}`} style={{ marginTop: '0.5rem', borderTop: '1px solid #ccc', paddingTop: '0.5rem' }}>
                    <TextField
                      id={`ptCodeProjectCode${index}`}
                      label="Project Code"
                      className={classes.textField}
                      value={ptCode.projectCode ? ptCode.projectCode : ''}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'projectCode')}
                      margin="normal"
                      required={true}
                      helperText="Required"
                      disabled={readonly}
                    />
                    <TextField
                      id={`ptCodeTaskCode${index}`}
                      label="Task Code"
                      className={classes.textField}
                      value={ptCode.taskCode ? ptCode.taskCode : ''}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'taskCode')}
                      margin="normal"
                      required={true}
                      helperText="Required"
                      disabled={readonly}
                    />
                    <TextField
                      id={`ptCodePercentage${index}`}
                      label="Percentage"
                      className={classes.textField}
                      type="number"
                      style={{ width: '125px' }}
                      value={ptCode.percentage !== null && ptCode.percentage !== undefined ? ptCode.percentage : ''}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'percentage')}
                      margin="normal"
                      inputProps={{ min: 0, max: 100, step: 0.01 }}
                      disabled={readonly}
                    />
                    <TextField
                      id={`ptCodeEffectiveStartDate${index}`}
                      label="Effective Start Date"
                      type="date"
                      style={{ width: '175px' }}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'effectiveStartDate')}
                      value={ptCode.effectiveStartDate ? ptCode.effectiveStartDate : ''}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={classes.textField}
                      disabled={readonly}
                      required={true}
                      helperText="Required"
                    />
                    <TextField
                      id={`ptCodeEffectiveEndDate${index}`}
                      label="Effective End Date"
                      type="date"
                      style={{ width: '175px' }}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'effectiveEndDate')}
                      value={ptCode.effectiveEndDate ? ptCode.effectiveEndDate : ''}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={classes.textField}
                      disabled={readonly}
                    />
                    <TextField
                      id={`ptCodeNotes${index}`}
                      label="Notes"
                      className={classes.textFieldWide}
                      value={ptCode.notes ? ptCode.notes : ''}
                      onChange={this.props.handlePTCodeHistoryChange(index, 'notes')}
                      multiline
                      minRows={1}
                      margin="normal"
                      disabled={readonly}
                      inputProps={{
                        style: {
                          overflowX: 'hidden',
                          whiteSpace: 'pre-wrap',
                          overflowWrap: 'anywhere',
                        },
                      }}
                    />
                    {!readonly &&
                      <IconButton
                        aria-label="Delete PT Code"
                        style={{ 'marginTop': '14px', 'marginLeft': '6px' }}
                        color="primary"
                        variant="contained"
                        onClick={() => this.props.handleDeletePTCodeHistory(index)}
                      >
                        <FontAwesomeIcon icon="trash" />
                      </IconButton>
                    }
                  </Grid>
                </>
              );
            })}
            {!readonly &&
              <Grid container item style={{ marginTop: '1rem' }}>
                <Button
                  onClick={this.props.handleAddPTCodeHistory}
                >
                  Add PT Code
                </Button>
              </Grid>
            }
          </>
        }
        </Paper>

        {/* {(ClientCustomFields.length > 0 || CustomFields.length > 0) &&
          <Paper className={classes.paperSection}>
            <h3>Employee Job Information</h3>
            <Grid container item>
              {ClientCustomFields &&
                ClientCustomFields.map((field, i) => {
                  if ((field.FieldName === 'InternStartDate' || field.FieldName === 'InternEndDate') && isSamsungClient() && MoveType !== 'INTERN') return null;
                  if(getSelectedClientInformation().id === '184' && field.FieldName === 'CostCenter') 
                  { 
                    field.FieldType = 'DropDownList';
                    field.TextFormat = 'List';
                  }

                  if (field.TextFormat === 'Date' && ( (field.disabled === undefined || field.disabled === false) || (field.disabled === true && field.FieldValue !== null && field.FieldName !== 'RemoveByDate') )) {
                    const fieldValue = field.FieldValue;


                    // format .net date strings
                    // example input: Apr 24 2018 12:00AM
                    const dotNetFormat = moment(fieldValue, 'MMM  D YYYY hh:mmA', true).isValid() ||
                      moment(fieldValue, 'MMM DD YYYY hh:mmA', true).isValid();

                    const formattedDate = dotNetFormat ? moment(fieldValue, 'MMM DD YYYY hh:mmA').format('YYYY-MM-DD').toString() : field.FieldValue;

                    // set updated value in field
                    field.FieldValue = formattedDate;

                    return (
                      <TextField
                        key={i}
                        id={`cfDate${  i}`}
                        label={field.FieldLabel}
                        placeholder={isIE ? 'yyyy-mm-dd' : null}
                        helperText={formattedDate ? validDate(formattedDate) : null}
                        type={isIE ? null : 'date'}
                        style={{ marginTop: '1rem' }}
                        onChange={handleClientCustomFieldChange(field)}
                        value={formattedDate ? formattedDate : ''}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required={field.FieldRequired}
                        disabled={readonly}
                      />
                    );
                  } else if (field.TextFormat === 'Number') {
                    return (
                      <TextField
                        className={classes.textField}
                        id={`cfNumber${  i}`}
                        key={`cfNumber${  i}`}
                        label={field.FieldLabel}
                        required={field.FieldRequired}
                        margin="normal"
                        onChange={handleClientCustomFieldChange(field)}
                        InputProps={{ inputComponent: IntegerFormat }}
                        value={field.FieldValue ? field.FieldValue : ''}
                        disabled={readonly}
                      />
                    );
                  } else if (field.TextFormat === 'List') {
                    if((field.UserGroup === 'Division' || field.FieldLabel === 'Division') && !isKLAClient())
                    {
                      if(field.FieldRequired === true)
                      {
                        field.FieldRequired = false;
                      }
                       let fieldBusCode = removeLettersFromBusCode(field.FieldName);
                       let currentBusCode = CustomFields[0].BusCodeKey;
                        
                        
                       
                       if(currentBusCode && fieldBusCode === currentBusCode.toString())
                       {
                        field.FieldRequired = true;
                        const listValues = field.FieldList.map((field) => {
                          if (safeIncludes(field, '%')) {
                            if (isBattelleEnergyAllianceClient() === true && safeIncludes(field, 'ChargeNum3')) { //Added via AB#869 for BEA Client
                              return { value: field, label: 'ASSIGNMENT' }; //Added via AB#869 for BEA Client
                            } else {
                              return { value: field, label: 'Other' }; //The default behavior for all other Clients
                            }
                          }
                          else if (safeIncludes(field, "|")) {
                            let fieldValue = field.split("|")[1].toString();
                            return { value: fieldValue, label: fieldValue };
                          }
                          else
                            return { value: field, label: field };
                        });
                        if (field.FieldList.length >= 2) {
                          // const mappedFieldList = field.FieldList.map((field) => ({ value: field, label: field }));
                            return (
                              <CustomSelect
                                id={`cfList${  i}`}
                                key={`cfList${  i}`}
                                options={listValues}
                                placeholder={field.FieldLabel}
                                validator={field.FieldRequired ? requiredField : null}
                                onChange={handleClientCustomFieldChange(field)}
                                value={field.FieldValue ? field.FieldValue : ''}
                                disabled={readonly || field.disabled}
                                longerSelect={true}

                              />
                            );                        
                        }
                        else if (field.FieldList.length === 1) {
                          field.FieldValue = (safeIncludes(field.FieldList[0], "|")) ? field.FieldList[0].split("|")[1] : field.FieldList[0];
                          return (
                              <CustomSelect
                                id={`cfList${  i}`}
                                key={`cfList${  i}`}
                                options={listValues}
                                placeholder={field.FieldLabel}
                                validator={field.FieldRequired ? requiredField : null}
                                onChange={handleClientCustomFieldChange(field)}
                                value={field.FieldValue ? field.FieldValue : ''}
                                disabled={readonly || field.disabled}

                              />
                            );      
                        }
                        else {
                          return (
                            <div></div>
                          );
                        }
                        
                          // <TextField
                          //   id={`cfList${  i}`}
                          //   select
                          //   label={field.FieldLabel}
                          //   className={classes.textField}
                          //   value={field.FieldValue ? field.FieldValue : ''}
                          //   onChange={handleClientCustomFieldChange(field)}
                          //   margin="normal"
                          //   key={`cfList${  i}`}
                          //   required={field.FieldRequired}
                          //   SelectProps={{
                          //     MenuProps: {
                          //       className: classes.menu,
                          //     },
                          //   }}
                          //   disabled={readonly || field.disabled}
                          // >
                          //   <MenuItem value="" />
                          //   {listValues.map((item, i) => {
                          //     return <MenuItem key={i} value={item.value}>{item.label}</MenuItem>;
                          //   })}
                          // </TextField>
                        //);
                       }
                       else if((field.UserGroup === 'Division' || field.FieldLabel === 'Division') && (currentBusCode === null || fieldBusCode !== currentBusCode.toString()))
                       {
                        return (
                            <div></div>
                          );
                       }
                       else
                       {
                        const listValues = field.FieldList.map((field) => {
                          if (safeIncludes(field, '%')) {
                            if (isBattelleEnergyAllianceClient() === true && safeIncludes(field, 'ChargeNum3')) { //Added via AB#869 for BEA Client
                              return { value: field, label: 'ASSIGNMENT' }; //Added via AB#869 for BEA Client
                            } else {
                              return { value: field, label: 'Other' }; //The default behavior for all other Clients
                            }
                          }
                          else if (safeIncludes(field, "|")) {
                            let fieldValue = field.split("|")[1].toString();
                            return { value: fieldValue, label: fieldValue };
                          }
                          else
                            return { value: field, label: field };
                        });
                        if (field.FieldList.length >= 2) {
                          // const mappedFieldList = field.FieldList.map((field) => ({ value: field, label: field }));
                            return (
                              <CustomSelect
                                id={`cfList${  i}`}
                                key={`cfList${  i}`}
                                options={listValues}
                                placeholder={field.FieldLabel}
                                validator={field.FieldRequired ? requiredField : null}
                                onChange={handleClientCustomFieldChange(field)}
                                value={field.FieldValue ? field.FieldValue : ''}
                                disabled={readonly || field.disabled}
                                longerSelect={true}

                              />
                            );                        
                        }
                        else if (field.FieldList.length === 1) {
                          field.FieldValue = (safeIncludes(field.FieldList[0], "|")) ? field.FieldList[0].split("|")[1] : field.FieldList[0];
                          return (
                              <CustomSelect
                                id={`cfList${  i}`}
                                key={`cfList${  i}`}
                                options={listValues}
                                placeholder={field.FieldLabel}
                                validator={field.FieldRequired ? requiredField : null}
                                onChange={handleClientCustomFieldChange(field)}
                                value={field.FieldValue ? field.FieldValue : ''}
                                disabled={readonly || field.disabled}

                              />
                            );      
                        }
                        else {
                          return (
                            <div></div>
                          );
                        }
                       }
                    }
                    else if(field.FieldName === 'CostCenter')
                    {
                      let currentBusCode = CustomFields[0].BusCodeKey;
                      if(currentBusCode && (currentBusCode.toString() === '852763' || currentBusCode.toString() === '852764')) { 
                        field.FieldRequired = false; 
                      }
                      else {
                        field.FieldRequired = true;
                      }
                      if(costCenters.length > 0)
                      {
                        field.FieldValue = costCenters[0];
                      }
                      return (
                        <TextField
                          id={`cfList${  i}`}
                          select
                          label={field.FieldLabel}
                          className={classes.textField}
                          value={field.FieldValue ? field.FieldValue : ''}
                          onChange={handleClientCustomFieldChange(field)}
                          margin="normal"
                          key={`cfList${  i}`}
                          required={field.FieldRequired}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          style={{ minWidth: 250 }}
                          disabled={readonly || field.disabled}
                        >
                          {costCenters.map((item) => {
                            return <MenuItem value={item}>{item}</MenuItem>;
                          })}
                        </TextField>
                      );
                    }
                    else {
                      const listValues = field.FieldList.map((f) => {
                        if (safeIncludes(f, '%')) {
                          if (isBattelleEnergyAllianceClient() === true && safeIncludes(f, 'ChargeNum3')) { //Added via AB#869 for BEA Client
                            return { value: f, label: 'ASSIGNMENT' }; //Added via AB#869 for BEA Client
                          } else {
                            return { value: f, label: 'Other' }; //The default behavior for all other Clients
                          }
                        }
                        else if (safeIncludes(f, "|") && field.FieldName === 'ValeroWorkLocation') {
                          let fieldValue = f.split("|")[0].toString();
                          return { value: fieldValue, label: fieldValue };
                        }
                        else if (safeIncludes(f, "|")) {
                          let fieldValue = f.split("|")[1].toString();
                          return { value: fieldValue, label: fieldValue };
                        }
                        else
                          return { value: f, label: f };
                      });
                      if (field.FieldList.length > 3) {
                        // const mappedFieldList = field.FieldList.map((field) => ({ value: field, label: field }));
                        if(isKLAClient() && field.UserFieldsId === 20452)
                        {
                          return (
                            // Added via AB#1324 to increase division dropdown width for KLA
                            <CustomSelect
                              id={`cfList${  i}`}
                              key={`cfList${  i}`}
                              options={listValues}
                              placeholder={field.FieldLabel}
                              validator={field.FieldRequired ? requiredField : null}
                              onChange={handleClientCustomFieldChange(field)}
                              value={field.FieldValue ? field.FieldValue : ''}
                              disabled={readonly || field.disabled}
                              longerSelect={true}
                            />
                          );
                        }
                        else {
                          return (
                            <CustomSelect
                              id={`cfList${  i}`}
                              key={`cfList${  i}`}
                              options={listValues}
                              placeholder={field.FieldLabel}
                              validator={field.FieldRequired ? requiredField : null}
                              onChange={handleClientCustomFieldChange(field)}
                              value={field.FieldValue ? field.FieldValue : ''}
                              disabled={readonly || field.disabled}
                            />
                          );
                        }
                      }
                      if (field.FieldList.length === 1) {
                        field.FieldValue = (safeIncludes(field.FieldList[0], "|")) ? field.FieldList[0].split("|")[1] : field.FieldList[0];
                      }
                      return (
                        <TextField
                          id={`cfList${  i}`}
                          select
                          label={field.FieldLabel}
                          className={classes.textField}
                          value={field.FieldValue ? field.FieldValue : ''}
                          onChange={handleClientCustomFieldChange(field)}
                          margin="normal"
                          key={`cfList${  i}`}
                          required={field.FieldRequired}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          disabled={readonly || field.disabled}
                        >
                          <MenuItem value="" />
                          {listValues.map((item, i) => {
                            return <MenuItem key={i} value={item.value}>{item.label}</MenuItem>;
                          })}
                        </TextField>
                      );
                    }
                  } else if (field.TextFormat === 'Currency') {
                    return (
                      <TextField
                        className={classes.textField}
                        id={`cfCurrency${  i}`}
                        key={`cfCurrency${  i}`}
                        label={field.FieldLabel}
                        margin="normal"
                        onChange={handleClientCustomFieldChange(field)}
                        InputProps={{ inputComponent: CurrencyFormat }}
                        required={field.FieldRequired}
                        value={field.FieldValue ? field.FieldValue : ''}
                        disabled={readonly || field.disabled}
                      />
                    );
                  } else {
                    const maxFieldLength = (isSolenisClient() && field.FieldName === 'SolenisCoCode') ? 4 : null;
                    if ( (field.disabled === undefined || field.disabled === false) || (field.disabled === true && field.FieldValue !== null && field.FieldName !== 'RemoveByDate') ) {
                      if(field.FieldName === 'BusinessCostCenter')
                      {
                        let currentBusCode = CustomFields[0].BusCodeKey;
                        if(currentBusCode && currentBusCode.toString() === '852763') { 
                          field.FieldRequired = true; 
                        }
                        else { 
                          field.FieldRequired = false; 
                        }
                        return (
                          <TextField
                            key={i}
                            label={field.FieldLabel}
                            className={classes.textField}
                            value={field.FieldValue ? field.FieldValue : ''}
                            onChange={handleClientCustomFieldChange(field)}
                            margin="normal"
                            required={field.FieldRequired}
                            disabled={readonly || field.disabled}
                          />
                        );
                      }
                      else {
                        return (
                          <TextField
                            key={i}
                            label={field.FieldLabel}
                            className={classes.textField}
                            value={field.FieldValue ? field.FieldValue : ''}
                            onChange={handleClientCustomFieldChange(field)}
                            inputProps={{ maxLength: maxFieldLength }}
                            margin="normal"
                            required={field.FieldRequired}
                            disabled={readonly || field.disabled}
                          />
                        );
                      }
                      
                    } else {
                      return null;
                    }
                  }
                })
              }
            </Grid>

            <Grid container item>
              {CustomFields &&
                CustomFields.map((field, i) => {
                  // exclude division from this list
                  if (field.BusCodeList !== DIVISION_BUS_CODE_LIST) {
                    const busCodeOptions = this.getBusCodes(field.BusCodeList);
                    if (busCodeOptions.length > 0) {
                      return (
                        <div>
                          <TextField
                            id={field.BusCode}
                            key={i}
                            select
                            label={field.BusCodeLabel}
                            className={classes.textFieldMedium}
                            value={field.BusCode ? field.BusCode : ''}
                            margin="normal"
                            required={field.IsRequired}
                            SelectProps={{
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}
                            disabled={readonly || field.disabled}
                            onChange={(event) => {
                              const { value } = event.target;
                              if (value) {
                                const busCode = busCodeOptions.find((instance) => instance.BusCode === value);
                                return handleCustomFieldChange(busCode);
                              } else {
                                field.BusCode = null;
                                field.BusCodeDesc = null;
                                if (field.User1) delete field.User1;
                                if (field.User2) delete field.User2;
                                field.BusCodeKey = null;
                                return handleCustomFieldChange(field);
                              }
                            }}
                          >
                            <MenuItem value="" />
                            {busCodeOptions.map((busCodeOption) => (
                              <MenuItem key={busCodeOption.BusCode} value={busCodeOption.BusCode}>
                                {busCodeOption.BusCode}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  } else {
                    return null;
                  }
                })
              }
            </Grid>
          </Paper>
        } */}

         {/* Add Estimate Section Here */}
         {this.props.baseMoveInfo && this.props.baseMoveInfo.EstimateId && this.props.baseMoveInfo.EstimateTotal &&
          <Paper className={classes.paperSection}>
            <h3>Estimate Information</h3>
            <Typography>Estimated Cost of Move: <b>{displayCost(parseFloat(this.props.baseMoveInfo.EstimateTotal), CostUnit.CURRENCY)}</b></Typography>
            <Box sx={{paddingTop: '10px'}}>
              <Typography>This total was calculated using Estimate ID {this.props.baseMoveInfo.EstimateId}. <Link to={`/estimates/${this.props.baseMoveInfo.EstimateId}`}>View full estimate.</Link></Typography>
            </Box>
          </Paper>
        }

      </form >
    );
  }
}

EmployeeForm.propTypes = {

};

const mapStateToProps = (state) => {
  return {
    countries: state.authorizations.get('countries'),
    states: state.authorizations.get('states'),
    clientDivisions: state.layout.get('clientDivisions'),
    baseMoveInfo: state.transferees.get('baseMoveInfo'),
    clientFields: state.authorizations.get('clientFields'),
    clientInfo: state.authorizations.get('clientInfo'),
    allEnums: state.authorizations.get('allEnums'),
    countryEnums: state.authorizations.get('countryEnums'),
    provinceEnums: state.authorizations.get('provinceEnums'),
  };
};

EmployeeForm = withStyles(styles)(EmployeeForm);

export default connect(mapStateToProps, {
  getAuthorizationCustomFields,
  getClientFieldListValues,
  getClientSpecificFields,
  getAllEnumerations,
  getAllCountries,
  getAllProvinces,
  getTempPendingAuthClientCustomFields,
  getClientInformation
})(EmployeeForm);
